import { styled } from "@mui/material";

export const AutocompleteCustomEndAdornment = styled("div")({
  position: "absolute",
  right: "12px",
  top: "50%",
  transform: "translate(0, -50%)",
  fontSize: "1.1rem",
});